export default __webpack_public_path__ + "static/anilPokhriyal3-dc4f3cd29d012aab835f19d7cf3c0f1b.jpg";